<template>
	
    <div class="profile-activity">
        <div class="profile-tabs">
            <button @click="selectTab(item.id)" 
                    v-for="(item, key) in tabItem"
                    :key="key"
                    :class="{ 'selectedTab' : currentTab == item.id}"
                    class="tab-btn">{{ item.title }}</button>
         
        </div> <!-- /. profile-tabs-end -->

        <div class="profile-tabs-details">
            <div v-if="currentTab == 1" class="single-tabs-details">
                <posts></posts>
            </div>
            <div v-if="currentTab == 2" class="single-tabs-details">
                <series-post></series-post>
            </div>
            <div v-if="currentTab == 3" class="single-tabs-details">
                <div class="not-found-post">
                    <img src="../../assets/icon/undraw_not_found.svg" alt="not-found" />
                    <h4>This profile doesn't have any posts</h4>
                </div>
            </div>
        </div> <!-- /. profile-tabs-end -->
    </div>

</template>

<script>


export default {
    name: "profile-activity",

    props: {
        value: String
    },

    data(){
        return{
            currentTab: 1,
            tabItem:[
                {
                    title: 'Posts',
                    id: 1
                },
                {
                    title: 'Series',
                    id: 2
                },
                {
                    title: 'Reactions',
                    id: 3
                }
            ]
        }
    },

    methods: {
        selectTab(selectedTab) {
            this.currentTab = selectedTab
        }
    }

}

</script>